import { LAST_MESSAGE_SORTING, SORT_TYPES } from '../../constants/props';

const sortByKey = (values, sortingKey, sortingType = SORT_TYPES.desc) => {
  if (!sortingKey) return values;

  return values.sort((a, b) => {
    let x = a[sortingKey] || 0;
    let y = b[sortingKey] || 0;

    if (sortingKey === LAST_MESSAGE_SORTING) {
      x = new Date(x);
      y = new Date(y);
    }

    return sortingType === SORT_TYPES.desc ? y - x : x - y;
  });
};

export default sortByKey;



// WEBPACK FOOTER //
// ./src/utils/sorting/index.js